import React, { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $convertFromMarkdownString, TRANSFORMERS } from '@lexical/markdown';

export function MarkdownInitializerPlugin({ value }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!value) return;

    if (typeof value === 'string') {
      editor.update(() => {
        $convertFromMarkdownString(value, TRANSFORMERS);
      });
    }
  }, [editor, value]);

  return null;
}
